import { AnyUser } from "@megaron/access-control";
import { HttpService } from "@megaron/http-service";
import { HandlerMap } from "@megaron/http-service-host";

import { dumpActions } from "./dump";
import { reports } from "./reports";

export const analyticsHttpService = HttpService({
  ...reports,
  ...dumpActions,
});

export type AnalyticsHandlers = HandlerMap<typeof analyticsHttpService, AnyUser>;
